import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  self: null,
  pending: false,
  users: { system: { name: 'Sherpa System' } },
  list: [],
  rooms: []
});

export function setUserSelf(state, user) {
  Raven.setUserContext({
    email: user.username
  });
  return state.merge({ pending: false, self: user });
}

export function setUserRoom(state, room) {
  return state.set('rooms', state.get('rooms').push(room));
}

export function setUserList(state, list) {
  const jsState = state.toJS();
  const { users } = jsState;
  list.forEach(item => {
    users[item.userId] = item;
  });
  return state.merge({ list, users });
}

export function addUserData(state, user) {
  const jsState = state.toJS();
  const { users } = jsState;
  users[user.userId] = user;
  return state.merge({ users });
}
export function clearUserSelf(state) {
  return state.set('pending', false).remove('self');
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'USER_SELF_SET':
      return setUserSelf(state, action.user);

    case 'USER_SELF_CLEAR':
      return clearUserSelf(state);

    case 'USER_FIND_BY_ID':
      return addUserData(state, action.user);

    case 'USER_SELF_PENDING':
      return setPendingSelf(state, action.pending);

    case 'USER_LIST':
      return setUserList(state, action.list);

    case 'USER_SET_ROOM':
      return setUserRoom(state, action.room);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/user.js